export default __webpack_public_path__ + "static/media/tutorial-complemento-info.7de2dbf0.mp4";